import { render, staticRenderFns } from "./AddProductToCart.vue?vue&type=template&id=b688e456"
import script from "./AddProductToCart.vue?vue&type=script&lang=js"
export * from "./AddProductToCart.vue?vue&type=script&lang=js"
import style0 from "./AddProductToCart.vue?vue&type=style&index=0&id=b688e456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports